import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Row, Col, Button } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import cn from 'classnames'
import { getFullAuthorById } from '../../../common/api/Courses'
import { getBreathingData } from '../../../common/api/Practices'
import { navigateTo } from '../../../common/navigation'
import useFetchByID from '../../../common/hooks/useFetchByID'
import { ROUTE_ACTIVITIES_BREATHING_ALL } from '../../../common/helpers/Paths'
import {
  EVENT_CATEGORY_BREATHWORK,
  EVENT_ACTION_PAGEVIEW,
  saveUserEvent
} from '../../../common/api/UserEvents'
import { PracticeIntro } from '../../PracticeIntro'
import { KEY_PRACTICE_BREATHWORK_WP } from 'components/common/api'

export default function BreathingIntro({
  setHeaderTitle,
  setReturnPath,
  cache
}) {
  const minutesArr = [1, 5, 10]

  const history = useHistory()
  const { breathingId } = useParams()
  const isLargeScreen = useMediaQuery({ minWidth: 992 })

  const cacheKey = `${ROUTE_ACTIVITIES_BREATHING_ALL}/intro/${breathingId}`
  const { data, isLoaded } = useFetchByID(
    getBreathingData,
    breathingId,
    cache,
    cacheKey
  )

  const authorID = data && data?.acf?.content_author[0]
  const author = useFetchByID(
    getFullAuthorById,
    authorID,
    cache,
    cacheKey + '/author'
  ).data

  useEffect(() => {
    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_BREATHING_ALL)

    saveUserEvent(EVENT_CATEGORY_BREATHWORK, EVENT_ACTION_PAGEVIEW, breathingId)
  }, [setHeaderTitle, setReturnPath, breathingId])

  const handleMinuteClick = minutes => {
    const url = `${ROUTE_ACTIVITIES_BREATHING_ALL}/${breathingId}/breath/${minutes}`
    navigateTo(url, history)
  }

  const getMinutes = args => {
    return (
      <>
        <Col
          md={4}
          className={cn('d-flex align-items-center', {
            'mb-3': !isLargeScreen
          })}
        >
          <h4 className='mb-0'>Start your practice</h4>
        </Col>
        <Col md={8} className='minutes-container text-center'>
          <Row className='flex-nowrap justify-content-center align-items-center'>
            {minutesArr.map(minute => (
              <Col key={minute}>
                <Button
                  size={args.buttonSize}
                  variant='outline-secondary'
                  onClick={() => handleMinuteClick(minute)}
                  className={cn('minute-button', {
                    'w-100': args.isFullWidth
                  })}
                >
                  <span>
                    {minute === 1 ? `${minute} minute` : `${minute} minutes`}
                  </span>
                </Button>
              </Col>
            ))}
          </Row>
        </Col>
      </>
    )
  }

  return (
    <PracticeIntro
      practiceId={breathingId}
      isLoading={isLoaded}
      authors={author}
      practiceData={data}
      getMinutes={getMinutes}
      practiceType={KEY_PRACTICE_BREATHWORK_WP}
    />
  )
}
